var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 21.8327H17.5833C18.158 21.8327 18.7091 21.6044 19.1154 21.1981C19.5217 20.7917 19.75 20.2407 19.75 19.666V2.33268C19.75 1.75805 19.5217 1.20695 19.1154 0.800617C18.7091 0.394289 18.158 0.166016 17.5833 0.166016H2.41667C1.84203 0.166016 1.29093 0.394289 0.884602 0.800617C0.478273 1.20695 0.25 1.75805 0.25 2.33268V19.666C0.25 20.2407 0.478273 20.7917 0.884602 21.1981C1.29093 21.6044 1.84203 21.8327 2.41667 21.8327H3.5ZM10 3.41493C11.7843 3.41493 13.25 4.87852 13.25 6.66493C13.25 8.45026 11.7843 9.91601 10 9.91601C8.21575 9.91601 6.75 8.45026 6.75 6.66493C6.75 4.87852 8.21575 3.41493 10 3.41493ZM3.5 16.6868C3.5 14.2829 6.43042 11.8118 10 11.8118C13.5696 11.8118 16.5 14.2829 16.5 16.6868V17.4993H3.5V16.6868Z",
    fill: "#5B5B5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.a175ce0117cf338c7c5df4947fe12d6b.svg";
export { ForwardRef as ReactComponent };